// TODO(security): this token ships in the client bundle. It must move server-side and be rotated
// (flagged on TRAV23-4671). Kept in one place so the legacy profile and the account hub share it.
const RENEWAL_PORTAL_TOKEN = 'r3iwH708P0d6VCMwvheoDheq0ZoRD0V8';

export const getRenewalPaymentUrl = (keyid: number | string | undefined): string =>
  `https://www.myvcaccount.com/Account/tokenpass/${encodeURIComponent(String(keyid))}?token=${RENEWAL_PORTAL_TOKEN}`;
